import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./MobileDrawer.css";

const MobileDrawer = ({ currentUser, open, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open, onClose]);

  if (!open) return null;

  const logout = async () => {
    try {
      await fetch("/backend/logout", {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      console.error("Server logout request failed:", error);
    } finally {
      localStorage.removeItem("currentUser");
      onClose();
      navigate("/login", { replace: true });
      window.location.reload();
    }
  };

  return (
    <>
      <button
        type="button"
        className="mobile-drawer-backdrop"
        onClick={onClose}
        aria-label="Close menu"
      />

      <aside className="mobile-drawer" aria-label="Account menu">
        <div className="mobile-drawer-header">
          <div>
            <strong>{currentUser?.username || "Scoldy user"}</strong>
            <div className="mobile-drawer-email">{currentUser?.email || ""}</div>
          </div>
          <button type="button" onClick={onClose} aria-label="Close menu">
            Close
          </button>
        </div>

        <nav className="mobile-drawer-links">
          <NavLink to="/profile" onClick={onClose}>Profile</NavLink>
          <NavLink to="/settings" onClick={onClose}>Settings</NavLink>
          <NavLink to="/cloud9" onClick={onClose}>Premium</NavLink>
          {currentUser?.group_id === 1 && (
            <NavLink to="/admin-tools" onClick={onClose}>Admin Tools</NavLink>
          )}
          <button type="button" onClick={logout}>Logout</button>
        </nav>
      </aside>
    </>
  );
};

export default MobileDrawer;
